import { HTTP_ADMIN_SUCCESS, HTTP_ADMIN_FETCHING, HTTP_ADMIN_FAILED } from '../constants';

const initialState = {
  result: null,
  isFatching: false,
  isError: false
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_ADMIN_FETCHING:
      return { ...state, result: [], isFetching: true, isError: false };
    case HTTP_ADMIN_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    case HTTP_ADMIN_FAILED:
      return { ...state, result: [], isFetching: false, isError: true };

    default:
      return state;
  }
};
